import MyAccountContainer from './MyAccountContainer';

export default MyAccountContainer;
